module.exports = __webpack_public_path__ + "static/img_4566-05d87848849a4070503a7cbd0de349a3.webp";